import axios from 'axios'
import { useEffect, useState } from 'react'
import { baseUrl } from '../baseUrl'
import { Link } from 'react-router-dom'
import { ThreeDots } from 'react-loader-spinner'

const RecommandedCourses = () => {
    const [courses, setCourses] = useState([]);
    const [loading,setLoading] =useState(true);

    const getCourses = async () => {
        setLoading(true);
        try{
            const response=await axios.get(`${baseUrl}/course/all`)
            setCourses(response.data)
        }catch(error){
            console.log(error)
        }finally{
            setLoading(false)
        }
    }

    useEffect(() => {  
        getCourses();
    }, [])
    return (
        <div id='recommonded-courses'>
            <section className="section-padding course-grid">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-7">
                            <div className="section-heading center-heading">
                                <h3 className='fs-3'>Courses at Monarchinstitute.in</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        {
                            loading &&
                            <div className='d-flex justify-content-center'>
                                <ThreeDots
                                    visible={true}
                                    height="80"
                                    width="80"
                                    color="#8000d5"
                                    radius="9"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                            </div>

                        }
                        {
                            !loading&&courses.length<1&&
                            <h4 className='text-center'>Coming Soon...</h4>
                        }
                        {
                            !loading&&courses.length>0&&
                            courses.map((c, i) =>
                                <div key={i} className="col-lg-3 col-md-6">
                                    <div className="course-block">
                                        <div className="course-img">
                                            <img src={`${process.env.REACT_APP_API_URL}${c.image}`} alt="" className="img-fluid" width={'100%'}/>
                                            <span className="course-label">{c.className}</span>
                                        </div>

                                        <div className="course-content">
                                            <span className="course-price text-decoration-line-through fs-5 mr-4">₹{c.originalPrice}</span>
                                            <span className="course-price fs-4">₹{c.price}</span>

                                            <h4><Link to={`/course/${c.courseID}`}>{c.title}</Link></h4>
                                            {/* <div className="rating">
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <span>(5.00)</span>
                                            </div> */}
                                            <p>{c.description.substring(0,50)+' . . .'}</p>

                                            <div className="course-footer d-lg-flex align-items-center justify-content-between">
                                                <div className="course-meta">
                                                    <span className="course-duration"><i className="bi bi-badge3"></i>{c.type==="Dynamic" ? "Unlimited" : c.tests} Tests</span>
                                                </div>
                                                <div className="buy-btn"><Link to={`/course/${c.courseID}`} className="btn btn-main-2 btn-small">Details</Link></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )
                        }
                    </div>


                    {/* <div className="row">
                        <div className="col-lg-12">
                            <nav className="blog-pagination text-center">
                                <ul>
                                    <li className="page-num active"><a href="#">1</a></li>
                                    <li className="page-num"><a href="#">2</a></li>
                                    <li className="page-num"><a href="#">3</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div> */}
                </div>
            </section>
            <section className="feature-2">
    <div className="container">
        <div className="row no-gutters">
            <div className="col-lg-3 col-md-6">
                <div className="feature-item feature-style-2">
                    <div className="feature-icon">
                        <i className="bi bi-badge2"></i>
                    </div>
                    <div className="feature-text">
                        <h4>Expert Tutor</h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-3 col-md-6">
                <div className="feature-item feature-style-2">
                    <div className="feature-icon">
                        <i className="bi bi-article"></i>
                    </div>
                    <div className="feature-text">
                        <h4>Quality Education</h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-3 col-md-6">
                <div className="feature-item feature-style-2">
                    <div className="feature-icon">
                        <i className="bi bi-headset"></i>
                    </div>
                    <div className="feature-text">
                        <h4>Liable Access</h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-3 col-md-6">
                <div className="feature-item feature-style-2">
                    <div className="feature-icon">
                        <i className="bi bi-rocket2"></i>
                    </div>
                    <div className="feature-text">
                        <h4>HD Video</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section className="about-section section-padding about-2">
    <div className="container">
        <div className="row align-items-center">
             <div className="col-lg-6 col-md-12">
               <div className="about-img2">
                   <img src="assets/images/bg/2-2.png" alt="" className="img-fluid"/>
               </div>
            </div>
            <div className="col-lg-6 col-md-12">
                <div className="section-heading">
                    <span className="subheading">Monarch Institute</span>
                    <h3>Why Monarch?</h3>
                </div>

                <p>We provide our services through a variety of formats, including Classroom instruction, Digital Learning, and Distance Learning Programs. Our Digital learning programs are designed for self-paced study, offering flexibility and allowing students to tailor their preparation to their individual needs. Our Distance Learning Programs are specifically intended for students who cannot attend in-person classes, offering expert guidance and result-oriented strategies to reinforce their understanding.</p>

                <Link to='/contact-us' className="btn btn-main"><i className="fa fa-check mr-2"></i>Learn More</Link>
                
            </div>
        </div>
    </div>
</section>
        </div>
    )
}

export default RecommandedCourses
